<div id="filePermissionsDialog"
  mat-dialog-container [class.dialog-container]="standalone"
  [class.embedded-dialog-container]="!standalone"
  class="file-manager"
  >
  <!-- upload mode -->
  @if (isUploadMode) {
    <div class="dialog-header" mat-dialog-title [attr.upload-mode]="true" [class.embedded-dialog-header]="!standalone">
      <div class="dialog-title file-manager-dialog-title" >
        {{ 'main.core.file_manager.access_for' | translate }} {{
        this.authenticationService._userInfoView.SelectedClient.ClientShortName }}
        {{'main.core.file_manager.download_tab' | translate}}
      </div>
    </div>
    <div class="file-manager__dialog-content" mat-dialog-content [class.embedded-dialog-content]="!standalone" >
      <input type="file" #UploadFileInput style="display:none;" (change)="onFileSelected($event)" />
      <br />
      <div class="file-manager__form">
        @if (isFileUploading) {
          <div id="fileUploadLoader" mat-dialog-content class="file-manager__loader">
            <img src="/assets/images/loader-sm.gif" width="20" height="20" />
          </div>
        }
        <div type="text" #FileNameInput class="form-control" style="width: 100%;"></div>
        <button class="dialog-button" (click)="selectFile()">{{ 'main.core.file_manager.select_file'
        | translate }}</button>
        @if (fileName !== '') {
          <button (click)="uploadFile()" class="dialog-button-default">{{
          'main.core.file_manager.upload' | translate }}</button>
        }
      </div>
    </div>
    <div class="dialog-footer" mat-dialog-actions>
      <button class="dialog-button-default" id="FileManagerConfirmButton" (click)="close()"
        title="{{ 'main.core.file_manager.confirm_and_close' | translate }}">
        {{ 'main.core.file_manager.cancel' | translate }}
      </button>
    </div>
  }
  <!-- end upload mode -->
  <!-- default mode -->
  @if (!isUploadMode) {
    <div [class.smaller-dialog-content]="useSmallerLists">
      <div [class.dialog-header]="standalone" mat-dialog-title  [class.embedded-dialog-header]="!standalone">
        @if (standalone) {
          <div class="dialog-title">
            {{ modalTitle? modalTitle : ('main.core.file_manager.access_for' | translate) + " " +
            fileQueryResult?.Name }}
          </div>
        }
        <div [class.dialog-subtitle]="standalone" [class.embedded-dialog-subtitle]="!standalone">
          @if (openFrom === 'downloads') {
            <p>{{ ('main.core.file_manager.subtitle_downloads' | translate) }}</p>
          }
          @if (openFrom === 'uploads') {
            <p>{{ ('main.core.file_manager.subtitle_upload' | translate) }}</p>
          }
          @if (openFrom !== 'downloads' && openFrom !== 'uploads') {
            <p>{{
            ('main.core.file_manager.subtitle_custom_grids' | translate) }}</p>
          }
        </div>
      </div>
      <div mat-dialog-content class="file-manager__dialog-content-list">
        <div class="restricted-or-public-select">
          <mat-icon [hidden]="!canEditPermissions()" class="lock-icon">
            {{restrictedOrPublicSelectModel[0] === "restricted" ? 'lock' : 'lock_open'}}
          </mat-icon>
          <rdo-multiselect-dropdown
            tabindex="0"
            title="Select visibility"
            id="restrictedOrPublicSelect"
            [disabled]="!canEditPermissions()"
            class="file-manager__select"
            [settings]="visibilitySelectSettings"
            [options]="visibilitySettingsOptions"
            [(ngModel)]="restrictedOrPublicSelectModel"
            (ngModelChange)="restrictedOrPublicSelectChange($event)"
            />
        </div>
        @if (allSelected) {
          <div>
            <p [class.embedded-dialog-subtitle]="true" class="dialog-subtitle">{{ noRestrictedUsersMessage }}</p>
          </div>
        }
        <div class="d-content flex-container file-manager__list" [class.disabled-area]="!canEditPermissions()">
          <div class="flex-child">
            <div class="selection-box-inner-title">{{ 'main.core.file_manager.grant_access_to_report' |
            translate }}</div>
            <mat-tree [dataSource]="usersByRoleDataSource" [treeControl]="treeService.treeControl"
              [class.embedded-mat-tree]="!standalone" [class.smaller-mat-tree]="useSmallerLists">
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                <button mat-icon-button disabled></button>
                <mat-checkbox
                  [class.disabled-area]="treeService.isUserSelectionDisabled(node, currentGridBranches)"
                  color="primary" class="checklist-leaf-node"
                  [checked]="treeService.usersSelection.isSelected(node)"
                (change)="treeService.todoLeafItemSelectionToggle(node, selectedUsers); refreshSaveBtnStatus();">{{node.item}}</mat-checkbox>
                @if (treeService.usersSelection.isSelected(node) && treeService.isUserSelectionDisabled(node, currentGridBranches)) {
                  <i
                    class="fa fa-fw fa-info-circle"
                    htmlTooltip="{{'main.core.file_manager.user_with_no_access_to_current_report' | translate}}"
                    tooltipPosition="right"></i>
                }
              </mat-tree-node>
              <mat-tree-node *matTreeNodeDef="let node; when: treeService.hasChild" matTreeNodePadding>
                <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="('main.core.file_manager.toggle' | translate) + ' ' + node.item">
                  <i class="fa" [class.fa-chevron-right]="!treeService.treeControl.isExpanded(node)"
                  [class.fa-chevron-down]="treeService.treeControl.isExpanded(node)"></i>
                  <!-- <mat-icon class="mat-icon-rtl-mirror" *ngIf="initialLoadCompleted">
                  {{treeService.treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon> -->
              </button>
              <mat-checkbox
                [class.disabled-area]="treeService.areDescendantsDisabled(node, currentGridBranches)"
                color="primary" [checked]="treeService.descendantsAllSelected(node)" class="parent-node"
                [indeterminate]="treeService.descendantsPartiallySelected(node)"
                (change)="treeService.todoItemSelectionToggle(node, selectedUsers); refreshSaveBtnStatus();"><span
              style="font-weight: 700;">{{node.item}}</span></mat-checkbox>
              @if (treeService.displayNonRdoTooltip(node, clientAvailableUsers)) {
                <i
                  class="fa fa-fw fa-info-circle"
                  htmlTooltip="{{'main.core.file_manager.non_rdo_user' | translate}}"
                  tooltipPosition="right">
                </i>
              }
            </mat-tree-node>
          </mat-tree>
        </div>
        <div class="flex-child">
          @if (!isDownloadsTab) {
            <div class="selected-box-inner-title">{{
            'main.core.file_manager.notify_user_by_email' | translate}}</div>
          }
          <mat-list #selectedUsersList [class.embedded-mat-list]="!standalone"
            [class.smaller-selected-list]="useSmallerLists">
            @if ((!this.selectedUsers || this.selectedUsers.length === 0) && initialLoadCompleted) {
              <mat-list-item
              class="no-restricted-users-message">{{noRestrictedUsersMessage}}</mat-list-item>
            }
            @if (canEditPermissions() && this.selectedUsers?.length > 0) {
              <mat-list-item
                class="list-item unselect-all">
                <div matListItemLine>
                  <span class="remove-button-container"><i class="fa fa-trash remove-button"
                  (click)="unSelectAll()"></i></span>
                  <span style="font-weight: 700;">{{ 'main.core.file_manager.unselect_all' | translate
                  }}</span>
                </div>
              </mat-list-item>
            }
            @for (selectedUser of selectedUsers; track selectedUser) {
              <mat-list-item class="list-item-right">
                <div matListItemLine>
                  @if (canEditPermissions() && userNotGeoRestricted(selectedUser)) {
                    <span
                      class="remove-button-container"><i class="fa fa-trash remove-button"
                    (click)="unSelect(selectedUser)"></i></span>
                  }
                  @if (userNotGeoRestricted(selectedUser)) {
                    <span>{{selectedUser.FirstName}}
                      {{selectedUser.LastName}} {{
                    selectedUser.UserId > -1 ? "(" + selectedUser.UserName + ")" : "" }}</span>
                  }
                  @if (!isDownloadsTab && userNotGeoRestricted(selectedUser)) {
                    <mat-checkbox
                      color="primary" class="checklist-leaf-node notification-checkbox"
                      [checked]="notificationUsersList.has(selectedUser.UserId)"
                      htmlTooltip="{{'main.core.file_manager.notification_checkbox_tooltip' | translate}}"
                    (change)="updateNotificationUsersList($event, selectedUser.UserId);"></mat-checkbox>
                  }
                </div>
                <!-- <div *ngIf="canEditPermissions()" class="remove-button-container"><i [ngClass]="{'disabled-trashcan': disableTrashCan(selectedUser)}" class="fa fa-trash remove-button" (click)="unSelect(selectedUser)"></i></div> -->
              </mat-list-item>
            }
          </mat-list>
        </div>
      </div>
    </div>
    @if (standalone) {
      <div class="dialog-footer responsive-footer" mat-dialog-actions>
        @if (!isDownloadsTab) {
          <div class="notification-message-box" [class.smaller-notification-box]="useSmallerLists"
            >
            <mat-form-field style="min-width: 100%; max-width: 100%;">
              <div><mat-label class="notification-label">{{ 'main.core.file_manager.optional_message' |
                translate
              }}</mat-label>
            </div>
            <div>
              <textarea [(ngModel)]="notificationMsg"
                class="notification-input"
                matInput
                matTextareaAutosize
                matAutosizeMinRows=1
                matAutosizeMaxRows=5
                placeholder="{{ 'main.core.file_manager.notification_message_placeholder' | translate }}"
                htmlTooltip="{{'main.core.file_manager.notification_message_placeholder' | translate}}"
                maxlength="255"></textarea>
            </div>
          </mat-form-field>
        </div>
      }
      @if (showDeleteFileBtn()) {
        <button class="dialog-button delete-file-button responsive-btn"
          id="FileManagerDeleteFileButton" (click)="deleteFile()"
          title="{{ 'main.core.file_manager.delete_file' | translate }}">
          {{ 'main.core.file_manager.delete_file' | translate }}
        </button>
      }
      <div class="file-manager__buttons">
        @if (showCancelBtn()) {
          <button class="dialog-button cancel-button responsive-btn"
            id="FileManagerConfirmButton" (click)="close(false)"
            title="{{ 'main.core.file_manager.cancel' | translate }}">
            {{ 'main.core.file_manager.cancel' | translate }}
          </button>
        }
        @if (showSaveBtn()) {
          <button [disabled]="isSaveDisabled()" [class.disabled]="isSaveDisabled()"
            class="dialog-button-default save-button responsive-btn" id="FileManagerDeleteFileButton"
            (click)="saveChanges()"
            [title]="avoidApiInteractions? ('main.core.file_manager.export' | translate) : ('main.core.file_manager.save_changes' | translate)">
            {{avoidApiInteractions? ('main.core.file_manager.export' | translate) :
            ('main.core.file_manager.save_changes' | translate) }}
          </button>
        }
      </div>
    </div>
  }
</div>
}
<!-- end default mode -->
</div>
